import { Input } from '@/components/ui/input'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { UseFormReturn } from 'react-hook-form'
import { z } from 'zod'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { statesArray } from '@/pages/subscribe/_data/subscribe-constant'

export const billingAddressSchema = z.object({
  address: z
    .string({
      required_error: 'Address is required field.',
    })
    .min(1, 'Address is required field.'),
  state: z
    .string({
      required_error: 'State is required field.',
    })
    .min(1, 'State is required field.'),
  city: z
    .string({
      required_error: 'City is required field.',
    })
    .min(1, 'City is required field.'),
  zipCode: z
    .string({
      required_error: 'ZIP code is a required field.',
    })
    .refine((val) => /^\d{5}$/.test(val.trim()), {
      message: 'Valid ZIP code is invalid.',
    }),
})

interface Props {
  form: UseFormReturn<any>
}

export default function PaymentMethodFormBillingAddress({ form }: Props) {
  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name="billingAddress.address"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Billing Address</FormLabel>
            <FormControl>
              <Input
                className="h-14"
                placeholder="Address (Street/House Number)"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <FormField
          control={form.control}
          name="billingAddress.state"
          render={({ field }) => (
            <FormItem>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger className="h-14">
                    <SelectValue placeholder="State/Region" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {statesArray.map((state) => (
                    <SelectItem key={state} value={state}>
                      {state}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="billingAddress.city"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Input className="h-14" placeholder="City" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="billingAddress.zipCode"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Input className="h-14" placeholder="ZIP/Postal" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  )
}
